import { useFormik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import edit from "../assets/images/icons/edit.png";
import PageHeader from "../Components/PageHeader";
import Table from "../Components/Table";
import TableContent from "../Components/TableContent";
import TableHeader from "../Components/TableHeader";
import * as Yup from "yup";
import InputField from "../Components/InputField";
import request, { URL } from "../services/request";
import endPoint from "../services/endPoint";
import { AppContext } from "../services/context";
import Notify from "../Components/Notify";
import tag from "../assets/images/tag.png";
import shopping from "../assets/images/shopping.png";
import group from "../assets/images/group.png";
import { toast } from "react-toastify";

const initData = {
  etat: "",
  nom: "",
  prenom: "",
  email: "",
  telephone: "",
  message: "",
  type_service: "",
  service: "",
};
const Commande = () => {
  const authCtx = useContext(AppContext);
  const { user } = authCtx;
  const [datas, setDatas] = useState([]);
  const [editId, setEditId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [viewData, setViewData] = useState({});
  const modal = useRef();
  const header = {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  useEffect(() => {
    getAll();
  }, [refresh]);
  const validateData = Yup.object({
    etat: Yup.string()
      .min(6, "l'état doit contenir au moins 6 caractères")
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    /*image: Yup.mixed()
      .required("Une image est requise")
      .test(
        "fileFormat",
        "Seuls les fichiers jpeg, png et gif sont autorisés",
        (value) => {
          return (
            value &&
            ["image/jpeg", "image/png", "image/gif"].includes(value.type)
          );
        }
      )
      .test("fileSize", "La taille maximale autorisée est de 2 Mo", (value) => {
        return value && value.size <= 2 * 1024 * 1024;
      }),*/
  });
  const formik = useFormik({
    initialValues: initData,
    validationSchema: validateData,
    onSubmit: (values) => {
      console.log(values);
      if (editId === "") {
        handleSubmit(values);
      } else {
        values._method = "put";
        handleEditSubmit(values);
      }
    },
  });

  const getAll = () => {
    request
      .get(endPoint.commandes, header)
      .then((res) => {
        setDatas(res.data.data);
        console.log(res.data)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSubmit = (values) => {
    toast.promise(request.post(endPoint.commandes, values, header), {
      pending: "Veuillez patienté...",
      success: {
        render({ data }) {
          console.log(data);
          const res = data;
          modal.current.click();
          getAll();

          return res.data.message;
        },
      },
      error: {
        render({ data }) {
          console.log(data);
          if (data?.response?.data?.message) {
            return data?.response?.data?.message;
          }
          return data?.response?.data?.errors
            ? data?.response?.data?.errors
            : data?.response?.data?.error;
        },
      },
    });
  };
  const handleEditSubmit = (values) => {
    //setShowModal(true)
    console.log(values);
    toast.promise(
      request.post(endPoint.commandes + "/" + editId, values, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;
            modal.current.click();
            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const onDelete = () => {
    toast.promise(
      request.delete(endPoint.commandes + "/" + viewData.slug, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;

            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const addModal = (e) => {
    e.preventDefault();
    setEditId("");
    formik.resetForm();
  };
  return (
    <>
      {/**
       * <div className="row">
        <div className="col-12">
          <div className="row row-cols-1 row-cols-sm-4">
            {[
              { name: "Marques", img: tag },
              { name: "Models", img: tag },
              { name: "Années", img: tag },
            ].map((data, idx) => {
              return (
                <div className="col mb-3" key={idx}>
                  <div className="card btn-primary-light p-4">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        <h6 className="text-16 fw-bold fs-4">{data.name}</h6>
                      </div>
                      <div className="ms-auto">
                        <img width="40px" src={data.img} alt="" />
                      </div>
                    </div>
                    <div>
                      <span>145</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
       */}
      <PageHeader title="Liste des commandes" modal="#form" addModal={addModal} />
      <Table>
        <TableHeader>
          <th scope="col" className="border-raduis-left">
            #
          </th>
          <th scope="col">Nº de commande</th>
          <th scope="col">Date</th>
          <th scope="col">Client</th>
          <th scope="col">Service</th>
          <th scope="col">Montant</th>
          <th scope="col" className="text-center">État</th>
          <th scope="col" className="text-center">
            Actions
          </th>
        </TableHeader>
        <TableContent>
          {datas.map((data, idx) => {
            return (
              <tr key={idx}>
                <td>
                  <input type="checkbox" value="selected" />
                </td>
                <td className="fw-bold">{data.numero_commande}</td>
                <td className="fw-bold">{new Date(data.created_at).toLocaleDateString()}</td>
                <td className="fw-bold">
                  <span>{data.nom + " " + data.prenom}</span><br />
                  <span>{data.email}</span><br />
                  <span>{data.telephone}</span><br />
                </td>
                <td className="fw-bold">{data.type_service}</td>
                <td className="fw-bold">{data.service_details?.prix} </td>
                <td className="fw-bold">
                  {
                    data.etat === "en_attente" ? (
                      <span className="badge bg-warning text-dark">En attente</span>
                    ) : data.etat === "en_cours" ? (
                      <span className="badge bg-info text-dark">En cours</span>
                    ) : data.etat === "termine" ? (
                      <span className="badge bg-success text-white">Terminée</span>
                    ) : (
                      <span className="badge bg-danger text-white">Annulée</span>
                    )
                  }
                </td>

                <td className="text-center">
                  <div className="btn-group">
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#view"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-eye-fill"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#form"
                        onClick={(e) => {
                          console.log(data);
                          formik.setFieldValue("id", data.slug);
                          formik.setFieldValue("etat", data.etat);
                          formik.setFieldValue("nom", data.nom);
                          formik.setFieldValue("prenom", data.prenom);
                          formik.setFieldValue("email", data.email);
                          formik.setFieldValue("telephone", data.telephone);
                          formik.setFieldValue("message", data.message);
                          formik.setFieldValue("type_service", data.type_service);
                          formik.setFieldValue("service", data.service_details.slug);
                          console.log(formik.values)
                          setEditId(data.slug);
                        }}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-pencil-square"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#delete"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          <i className="bi bi-trash3-fill"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </TableContent>
      </Table>
      <div className="modal fade" id="form">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                {editId !== ""
                  ? "Modification d’une année"
                  : "Ajout d’une année"}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={formik.handleSubmit}>
                <InputField
                  type={"select"}
                  name="etat"
                  formik={formik}
                  placeholder="Sélectionner l'état"
                  label={"Etat"}
                  options={[
                    { label: "En attente", id: "en_attente" },
                    { label: "En cours", id: "en_cours" },
                    { label: "Terminé", id: "termine" },
                    { label: "Annulé", id: "annule" },
                  ]}
                />
                <div className="d-flex justify-content-start border-0">
                  <button
                    type="reset"
                    className="btn btn-primary-light me-2"
                    data-bs-dismiss="modal"
                    ref={modal}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Enregistrer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">Suppression</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div>Voulez-vous supprimer définitivement les données ?</div>
              <div className="mt-4 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  data-bs-dismiss="modal"
                >
                  Non
                </button>
                <button
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={onDelete}
                >
                  Oui
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="view">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                Informations
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body text-center1 p-0">

              <div>
                <CommandeCard viewData={viewData} />
              </div>
              <div className="card mt-4 d-flex justify-content-end">
                <button className="btn btn-primary" data-bs-dismiss="modal">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Notify showModal={showModal} />
    </>
  );
};

export default Commande;



const CommandeCard = ({ viewData }) => {
  if (!viewData) return null;

  const {
    numero_commande,
    etat,
    nom,
    prenom,
    email,
    telephone,
    message,
    created_at,
    type_service,
    service_details,
  } = viewData;

  const vehicule = service_details?.vehicule;
  const modelMarque = vehicule?.model_marque;
  const marque = modelMarque?.marque;
  const annee = modelMarque?.annee;
  const categorie = vehicule?.categorie;
  const pays = vehicule?.pays;

  return (
    <div className="card mb-4">
      <div className="card-header bg-primary text-white">
        <strong>Commande #{numero_commande}</strong> - État :{' '}
        <span className="badge bg-warning text-dark">
          {etat?.replace('_', ' ')}
        </span>
      </div>
      <div className="card-body">
        <h5 className="card-title">Client : {nom} {prenom}</h5>
        <p className="card-text">
          <strong>Email :</strong> {email} <br />
          <strong>Téléphone :</strong> {telephone} <br />
          <strong>Message :</strong> {message}
        </p>

        <hr />
        <h6 className="text-primary">Détails du Service : {type_service}</h6>
        <ul className="list-group mb-3">
          <li className="list-group-item"><strong>Prix :</strong> {service_details?.prix} FCFA</li>
          <li className="list-group-item"><strong>Garantie moteur :</strong> {service_details?.garantie_moteur} mois</li>
          <li className="list-group-item"><strong>Statut :</strong> {service_details?.statut}</li>
          <li className="list-group-item"><strong>Kilométrage :</strong> {service_details?.kilometrage} km</li>
          <li className="list-group-item"><strong>Condition :</strong> {service_details?.condition}</li>
          <li className="list-group-item"><strong>Validation :</strong> {service_details?.etat_validation}</li>
        </ul>

        <h6 className="text-primary">Détails du Véhicule</h6>
        <ul className="list-group">
          <li className="list-group-item"><strong>Modèle :</strong> {marque?.label} {modelMarque?.label} ({annee?.label})</li>
          <li className="list-group-item"><strong>Carburant :</strong> {vehicule?.carburant_type}</li>
          <li className="list-group-item"><strong>Transmission :</strong> {vehicule?.transmission}</li>
          <li className="list-group-item"><strong>Boîte de vitesse :</strong> {vehicule?.boite_de_vitesse}</li>
          <li className="list-group-item"><strong>Portes :</strong> {vehicule?.nombre_de_portes}</li>
          <li className="list-group-item"><strong>Places :</strong> {vehicule?.nombre_de_places}</li>
          <li className="list-group-item"><strong>Catégorie :</strong> {categorie?.label}</li>
          <li className="list-group-item"><strong>Pays :</strong> {pays?.label}</li>
          <li className="list-group-item"><strong>Description :</strong> {vehicule?.description}</li>
        </ul>
      </div>
      <div className="card-footer text-muted">
        Créée le : {new Date(created_at).toLocaleString()}
      </div>
    </div>
  );
};